// extracted by mini-css-extract-plugin
module.exports = {"NavItemsStyles":"NavItems_NavItemsStyles__37agz"};